import { useSelector } from "react-redux";

import type { PresenceState } from "../app/presence/presenceSlice";

type RootStateLike = {
  presence: PresenceState;
};

/**
 * サーバ側 user_id は number で配信されるが、UI 側のモデルでは
 * MessageUser.id のように `number | string` 混在で持つ箇所がある。
 * 数値化に失敗したものはオフライン扱いとする。
 */
const toNumericUserId = (userId: number | string | null | undefined): number | null => {
  if (userId === null || userId === undefined || userId === "") return null;
  const num = typeof userId === "number" ? userId : Number(userId);
  return Number.isFinite(num) ? num : null;
};

/**
 * 指定ユーザーが現在オンラインかを返すフック。
 * `userId` が未確定 (null/undefined/空文字)、または数値化できない場合は常に false。
 */
export const useIsUserOnline = (userId: number | string | null | undefined): boolean =>
  useSelector((state: RootStateLike) => {
    const numericId = toNumericUserId(userId);
    if (numericId === null) return false;
    return state.presence.onlineUserIds.includes(numericId);
  });
